export type OrderPaymentMessages = {
  // Titles
  paymentInformationTitle: string;
  paymentDetailsDialogTitle: string;

  // Labels
  itemSkuLabel: string;
  itemProductLabel: string;
  itemQuantityLabel: string;
  itemPriceLabel: string;
  itemTotalLabel: string;
  paymentDetailsButtonLabel: string;

  // Error messages
  unknownPaymentMethodMessage: string;

  // Payment details
  paymentDetailsModalTitle: string;
  paymentDetailsModalCloseLabel: string;
};

export const ORDER_PAYMENT_MESSAGES: OrderPaymentMessages = {
  // Titles
  paymentInformationTitle: "Pagamentos",
  paymentDetailsDialogTitle: "Detalhes do pagamento",

  // Labels
  itemSkuLabel: "SKU",
  itemProductLabel: "Produto",
  itemQuantityLabel: "Quantidade",
  itemPriceLabel: "Preço",
  itemTotalLabel: "Total",
  paymentDetailsButtonLabel: "Detalhes",

  // Error messages
  unknownPaymentMethodMessage: "Método de pagamento desconhecido",

  // Payment details
  paymentDetailsModalTitle: "Detalhes do pagamento",
  paymentDetailsModalCloseLabel: "Fechar",
};
